import React from 'react';
import { Center, Loader } from '@good/ui/core';

/** Full-viewport centered spinner used as the Suspense fallback for lazy-loaded routes. */
export function PageLoader() {
  return (
    <Center style={{ height: '100vh', width: '100%' }}>
      <Loader />
    </Center>
  );
}
